import { render, staticRenderFns } from "./ShipReviewTrendAnalysisTopItem.vue?vue&type=template&id=19674600&"
import script from "./ShipReviewTrendAnalysisTopItem.vue?vue&type=script&lang=js&"
export * from "./ShipReviewTrendAnalysisTopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports